export default __webpack_public_path__ + "static/media/1.8492a6a9.png";